
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Image } from '@ta-interaktiv/contentbricks'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>
  Hinter der KG Gastrokultur stecken vier Quereinsteiger: Igor Gaic, Marc Häni,
  Regula Keller und Michel Gygax. «Früh merkten wir: Wenn wir bis zum
  Pensionsalter in der Gastronomie arbeiten wollen, müssen wir einen schlauen
  Plan haben, denn die Gastrobranche kann einen verschleissen», sagt Gygax. Sie
  eröffneten mehrere Lokale in zehn Jahren und setzen dort jeweils
  Geschäftsführer ein. Noch immer sind sie an der Servicefront tätig, aber nicht
  mehr täglich, damit sie ein normales Sozialleben führen können. Die KG
  Gastrokultur setzt auf Quartierbeizen mit frischer Küche zu fairen Preisen.
  Und auf Kulturanlässe: Im Du Nord in der Lorraine dreht auch mal eine
  Discokugel ihre Runden, und hier startete der mittlerweile stadtbekannte Event
  «Bier versus Wein».
    </p>
    <p>
  Das Lokal wird täglich von Anrainern und unter der Woche von Gewerbeschülern
  frequentiert. Im Marzer im Marziliquartier inspirieren Künstler die Köche für
  ein Mehrgangmenü. Das Restaurant Eiger am Eigerplatz wird im Quartier
  geschätzt. «Wir haben mittlerweile eine Firmengrösse, die immer noch sehr
  persönlich ist», sagt Gygax. Auch in Köniz ist das Unternehmen vertreten: mit
  dem Restaurant Zum Schloss, wo das Gemüse neu aus dem Schlossgarten kommt, und
  mit Le Beizli im Kultur- und Gewerbeareal der Vidmarhallen.
    </p>
    <Image file={require('images/gastrokultur_2.jpg')} source='Im Du Nord fing alles an. Die vier Quereinsteiger setzen auf Quartierbeizen und auf langsamen Wachstum. Bild: Beat Mathys' mdxType="Image" />
    <p>
  Praktisch für die KG-Beizer ist die eigene Weinhandlung, von der sie alle
  eigenen Betriebe beliefern. Ihre Mitarbeiterfluktuation sei für das
  Gastgewerbe recht tief, sagt Gygax. Mitarbeitende würden oft nach Reisen
  zurückkehren. Da das Personal die Unternehmensphilosophie kennt, hilft es
  trotz Stammbetrieb auch mal in einem Schwesterbetrieb aus. «Wir haben
  Schichten ohne Zimmerstunden, was unsere Mitarbeitenden initiierten und jetzt
  schätzen», sagt Gygax. Ungefähr 65 Festangestellte teilen sich 50
  Vollzeitstellen. Der Umsatz liegt bei knapp 7 Millionen Franken.
    </p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;